import { useGetAppConfig } from './useGetAppConfig';
import {
  Box,
  Switch,
  Tooltip,
  IconButton,
  Typography,
} from '@mui/material';
import { Semaphore } from './Semaphore';
import LockIcon from '@mui/icons-material/Lock';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export const CalendarIntegration = () => {
  const {
    remoteAppConfig: { ff_calendarIntegration },
  } = useGetAppConfig();

  return (
    <Box marginTop="2rem">
      <Box
        display="flex"
        alignItems="center"
        gap={0.5}
        marginBottom={1}
      >
        <Typography variant="h6">Calendar Integration</Typography>
        <Tooltip title="This feature is stable and permanently enabled. The flag will be removed in a future update.">
          <IconButton size="small" sx={{ padding: 0.5 }}>
            <HelpOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        gap={1}
      >
        <Box display="flex" alignItems="center" gap={0.5}>
          <LockIcon
            sx={{ fontSize: '1rem', color: 'text.secondary' }}
          />
          <Switch checked={ff_calendarIntegration} disabled={true} />
        </Box>
        <Box
          marginLeft="1rem"
          display="flex"
          flexDirection="row"
          alignItems="center"
        >
          <Semaphore enabled={ff_calendarIntegration} />
        </Box>
      </Box>
    </Box>
  );
};
